import {Item} from "../../../users/interfaces/dashboard.interface";
import {Injectable, OnInit, signal, ViewChild, WritableSignal} from "@angular/core";
import {LoginServices} from "../../../auth/login/services/login.service";
import {AsignacionesService} from "./asignaciones.service";
import {Param} from "../../../shared/interfaces/param-interface";
import {FiltersService} from "../../../shared/services/filters-service";
import {convertDate} from "../../../shared/services/utils-service";
import { ProyectoItem } from "src/app/users/interfaces/proyecto.interface";
import { ProyectoService } from "src/app/users/proyectos/services/proyecto.service";
import { DatePipe } from "@angular/common";

@Injectable({providedIn: 'root'})
export class AsignacionesDataService implements OnInit {
    private _itemsPorEstado: WritableSignal<Item[]> = signal([])
    private _itemsPorUsuarios: WritableSignal<Item[]> = signal([])
    private _itemsPorTipoProyecto: WritableSignal<Item[]> = signal([])
    private _itemsPorTipoTramite: WritableSignal<Item[]> = signal([])
    private _itemsPorSector: WritableSignal<Item[]> = signal([])
    private ejecuciones = 0;

    rangoDeFechas: Date[] | undefined;
    proyectos: ProyectoItem[] = []

    constructor(private loginServices: LoginServices, private asignacionesService: AsignacionesService,
                private filtersService: FiltersService) {
        this._itemsPorEstado.set([])
        this._itemsPorUsuarios.set([])
        this._itemsPorTipoProyecto.set([])
    }
    ngOnInit(): void {
        
    }

    q1resumenGlobalDeEstados(filterByCurrentUser?: boolean) {
        let params: Param[] = [];
        let estadosDefault = "0";
        if (this.loginServices.isRolGerenteTecnico()) {
            estadosDefault = "1,2,3,4,5,6,7,8,9,10,11,12,13";
        } else if (this.loginServices.isRolTecnicoResolutor()) {
            estadosDefault = "2,3,4,5,6,7,8,9,10,11,12,13";
        } else if (this.loginServices.hasRoles(['receptor'])) {
            estadosDefault = "1";
        }
        let drange = this.filtersService.selectedRange;
        let desde;
        let hasta;
        if (drange != null) {
            desde = convertDate(drange[0]);
            hasta = convertDate(drange[1]);
        }
        //Valida que el filtro por el usuario actual sea tecnico resolutor aunque tenga más roles.
        if (filterByCurrentUser != null && filterByCurrentUser && this.loginServices.isRolTecnico() && (!this.loginServices.isRolGerenteTecnico())) {
            console.log("FILTER BY CURRENT USER");
            params.push({key: "q1_uniqueid_asig", value: this.loginServices.session()?.perfil?.uniqueId.toString()!});
            params.push({key: "q1_estados", value: estadosDefault});
            params.push({key: "q1_desde", value: desde});
            params.push({key: "q1_hasta", value: hasta});
        } else {
            params.push({key: "q1_estados", value: estadosDefault});
            params.push({key: "q1_desde", value: desde});
            params.push({key: "q1_hasta", value: hasta});
        }
        if (this.loginServices.isRolGerenteTecnico()) {
            params.push({key: "q1_tipo", value: '1,2'});
        } else if(this.loginServices.isRolTecnicoResolutor()){
            params.push({key: "q1_tipo", value: '1,2,3'});
        } else if (this.loginServices.isRolJefeRegistro() || this.loginServices.isRolTecnicoRegistro()) {
            params.push({key: "q1_tipo", value: '3'});
        } else {
            params.push({key: "q1_tipo", value: '1,2,3'});
        }

        console.log(`q1resumenGlobalDeEstados.params:${JSON.stringify(params)}`);
        this.asignacionesService.q1resumenGlobalDeEstados(params)
            .subscribe({
                next: (result) => {
                    this._itemsPorEstado.set([])
                    if (result && result.body) {
                        this._itemsPorEstado.set(result.body)
                    }
                },
                error: (error) => {
                    console.log(error)
                }
            });
    }

    q2resumenGlobalDeUsuarios(filterByCurrentUser?: boolean) {
        let params: Param[] = [];
        let drange = this.filtersService.selectedRange;
        if (drange != null) {
            let desde = convertDate(drange[0]);
            let hasta = convertDate(drange[1]);
            params.push({key: "q2_desde", value: desde});
            params.push({key: "q2_hasta", value: hasta});
        }
        if (filterByCurrentUser != null && filterByCurrentUser) {
            params.push({key: "q2_uniqueid", value: this.loginServices.session()?.perfil?.uniqueId.toString()!});
        }
        this.asignacionesService.q2resumenGlobalDeUsuarios(params)
            .subscribe({
                next: (result) => {
                    if (result && result.body) {
                        this._itemsPorUsuarios.set(result.body)
                    }
                },
                error: (error) => {
                    console.log(error)
                }
            });
    }

    q4resumenGlobalPorTipoProyecto() {
        let params: Param[] = [];
        let drange = this.filtersService.selectedRange;
        if (drange != null) {
            let desde = convertDate(drange[0]);
            let hasta = convertDate(drange[1]);
            params.push({key: "q4_desde", value: desde});
            params.push({key: "q4_hasta", value: hasta});
        }
        if (this.loginServices.isRolGerenteTecnico() || this.loginServices.isRolTecnicoResolutor()) {
            params.push({key: "q4_tipo", value: '1,2'});
        } else if (this.loginServices.isRolJefeRegistro() || this.loginServices.isRolTecnicoRegistro()) {
            params.push({key: "q4_tipo", value: '3'});
        } else {
            params.push({key: "q4_tipo", value: '1,2,3'});
        }
        this.asignacionesService.q4resumenGlobalPorTipoProyecto(params)
            .subscribe({
                next: (result) => {
                    if (result && result.body) {
                        this._itemsPorTipoProyecto.set(result.body)
                    }
                },
                error: (error) => {
                    console.log(error)
                }
            });
    }

    q5resumenGlobalPorTipoTramite() {
        let params: Param[] = [];
        let drange = this.filtersService.selectedRange;
        if (drange != null) {
            let desde = convertDate(drange[0]);
            let hasta = convertDate(drange[1]);
            params.push({key: "q5_desde", value: desde});
            params.push({key: "q5_hasta", value: hasta});
        }
        this.asignacionesService.q5resumenGlobalPorTipoTramite(params)
            .subscribe({
                next: (result) => {
                    if (result && result.body) {
                        this._itemsPorTipoTramite.set(result.body)
                    }
                },
                error: (error) => {
                    console.log(error)
                }
            });
    }

    q6resumenGlobalPorSector() {
        let params: Param[] = [];
        let drange = this.filtersService.selectedRange;
        if (drange != null) {
            let desde = convertDate(drange[0]);
            let hasta = convertDate(drange[1]);
            params.push({key: "q6_desde", value: desde});
            params.push({key: "q6_hasta", value: hasta});
        }
        if (this.loginServices.isRolGerenteTecnico() || this.loginServices.isRolTecnicoResolutor()) {
            params.push({key: "q6_tipo", value: '1,2'});
        } else if (this.loginServices.isRolJefeRegistro() || this.loginServices.isRolTecnicoRegistro()) {
            params.push({key: "q6_tipo", value: '3'});
        } else {
            params.push({key: "q6_tipo", value: '1,2,3'});
        }
        this.asignacionesService.q6resumenGlobalPorSector(params)
            .subscribe({
                next: (result) => {
                    if (result && result.body) {
                        this._itemsPorSector.set(result.body)
                    }
                },
                error: (error) => {
                    console.log(error)
                }
            });
    }

    get itemsPorEstado(): WritableSignal<Item[]> {
        return this._itemsPorEstado;
    }

    set itemsPorEstado(value: WritableSignal<Item[]>) {
        this._itemsPorEstado = value;
    }

    get itemsPorUsuarios(): WritableSignal<Item[]> {
        return this._itemsPorUsuarios;
    }

    set itemsPorUsuarios(value: WritableSignal<Item[]>) {
        this._itemsPorUsuarios = value;
    }

    get itemsPorTipoProyecto(): WritableSignal<Item[]> {
        return this._itemsPorTipoProyecto;
    }

    set itemsPorTipoProyecto(value: WritableSignal<Item[]>) {
        this._itemsPorTipoProyecto = value;
    }

    get itemsPorTipoTramite(): WritableSignal<Item[]> {
        return this._itemsPorTipoTramite;
    }

    set itemsPorTipoTramite(value: WritableSignal<Item[]>) {
        this._itemsPorTipoTramite = value;
    }

    get itemsPorSector(): WritableSignal<Item[]> {
        return this._itemsPorSector;
    }

    set itemsPorSector(value: WritableSignal<Item[]>) {
        this._itemsPorSector = value;
    }
}
